import { createStyles, makeStyles } from '@material-ui/core/styles';
export default makeStyles(theme => {
  return createStyles({
    dialogTitleStyle: {
      display: 'flex',
      width: '100%',
      justifyContent: 'space-between',
      alignItems: 'center'
    },
    closeIcon: {
      '&:hover': {
        cursor: 'pointer'
      }
    },
    submitButton: {
      display: 'flex',
      margin: theme.spacing(1, 2, 3, 0),
      alignItems: 'flex-end'
    },
    submitButtonOptional: {
      display: 'flex',
      margin: theme.spacing(1, 2, 2),
      alignItems: 'flex-end'
    },
    actionButtons: {
      margin: theme.spacing(1, 2, 2),
      display: 'flex',
      '& > div:not(:last-child)': {
        marginRight: theme.spacing(1)
      }
    }
  });
});